const textProps = {
  defaultOpened: 0,
  items: [
    {
      title: "Sarah Smith",
      description:
        "Take up one idea. Make that one idea your life - think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success. A single rose can be my garden... a single friend, my world.",
      image: require("assets/img/faces/brooke-cagle.jpg").default,
      color: "indigo",
      button: {
        children: "read more",
      },
    },
    {
      title: "Isaac Hunter",
      description:
        "Take up one idea. Make that one idea your life - think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success. A single rose can be my garden... a single friend, my world.",
      image: require("assets/img/faces/fezbot.jpg").default,
      color: "teal",
      button: {
        children: "read more",
      },
    },
  ],
};
export default textProps;
